export default class KlevuRecsApiLayer {
  constructor () {
    this.apiKey = 'klevu-173091196240917713'
    this.endpoint = 'eucs34v2.ksearchnet.com'

    this.getUUID()
  }

  async getUUID () {
    const url = `https://stats.ksearchnet.com/analytics/uuid`

    const options = {
      method: 'POST',
      url,
      headers: {
        'Content-Type': 'application/json',
      },
    }

    const response = await fetch(url, options)
    const data = await response.json()

    sessionStorage.setItem('klevu_uuid', data.klevu_uuid)
    sessionStorage.setItem('klevu_ip_address', data.ip_address)
  }

  async fetchCustomersAlsoViewed (variantId) {
    const url = `https://${this.endpoint}/cs/v2/search`

    const options = {
      method: 'POST',
      url,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        recordQueries: [
          {
            id: "recsAlsoViewed",
            typeOfRequest: "RECS_ALSO_VIEWED",
            settings: {
              context: {
                recentObjects: [
                  {
                    typeOfRecord: "KLEVU_PRODUCT",
                    records: [
                      {
                        id: variantId
                      }
                    ]
                  }
                ]
              },
              typeOfRecords: ["KLEVU_PRODUCT"],
            }
          }
        ],
        context: {
          apiKeys: [this.apiKey],
        },
      }),
    }

    const response = await fetch(url, options)
    const data = await response.json()

    return data
  }

  async fetchRecentlyViewed (query) {
    const url = `https://${this.endpoint}/cs/v2/search`
    const recentlyViewedIds = JSON.parse(localStorage.getItem('BAO-recentlyViewedProducts'))
    const idStringForQuery = `(${recentlyViewedIds.map(id => `id:"${id}"`).join(" OR ")})`;

    const options = {
      method: 'POST',
      url,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        recordQueries: [
          {
            id: "recsRecentlyViewed",
            typeOfRequest: "SEARCH",
            settings: {
              customANDQuery: idStringForQuery,
              typeOfRecords: [
                "KLEVU_PRODUCT"
              ]
            }
          }
        ],
        context: {
          apiKeys: [this.apiKey],
        },
      }),
    }

    const response = await fetch(url, options)
    const data = await response.json()

    return data
  }

  async fetchAlsoBought (variantId) {
    const url = `https://${this.endpoint}/cs/v2/search`

    const options = {
      method: 'POST',
      url,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        recordQueries: [
          {
            id: "recsAlsoBought",
            typeOfRequest: "RECS_ALSO_BOUGHT",
            settings: {
              context: {
                recentObjects: [
                  {
                    typeOfRecord: "KLEVU_PRODUCT",
                    records: [
                      {
                        id: variantId
                      }
                    ]
                  }
                ]
              },
              typeOfRecords: ["KLEVU_PRODUCT"],
            }
          }
        ],
        context: {
          apiKeys: [this.apiKey],
        },
      }),
    }

    const response = await fetch(url, options)
    const data = await response.json()

    return data
  }

  async fetchSimilarProducts (variantId) {
    const url = `https://${this.endpoint}/cs/v2/search`

    const options = {
      method: 'POST',
      url,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        recordQueries: [
          {
            id: "recsAlsoViewed",
            typeOfRequest: "RECS_SIMILAR",
            settings: {
              context: {
                recentObjects: [
                  {
                    typeOfRecord: "KLEVU_PRODUCT",
                    records: [
                      {
                        id: variantId
                      }
                    ]
                  }
                ]
              },
              typeOfRecords: ["KLEVU_PRODUCT"],
            }
          }
        ],
        context: {
          apiKeys: [this.apiKey],
        },
      }),
    }

    const response = await fetch(url, options)
    const data = await response.json()

    return data
  }
}
